// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.load-progress-bar-container {
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 2;
    display: flex;
    align-items: center;
    margin: 0;
}
@media (max-width: 767px) {
.load-progress-bar-container {
        right: 0;
        bottom: 0;
        justify-content: center;
        width: 100%;
        border-radius: 0;
}
}
.loading-indicator {
    margin-right: 0.5em;
    animation: loading-indicator-spin 1s linear infinite;
}
@keyframes loading-indicator-spin {
from {
        transform: rotate(0deg);
}
to {
        transform: rotate(360deg);
}
}
`, "",{"version":3,"sources":["webpack://./src/components/helpers/load-progress-bar.vue"],"names":[],"mappings":";AA4BA;IACA,eAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;AACA;AAEA;AACA;QACA,QAAA;QACA,SAAA;QACA,uBAAA;QACA,WAAA;QACA,gBAAA;AACA;AACA;AAEA;IACA,mBAAA;IACA,oDAAA;AACA;AAEA;AACA;QACA,uBAAA;AACA;AAEA;QACA,yBAAA;AACA;AACA","sourcesContent":["<template>\n    <div v-if=\"display\" class=\"load-progress-bar-container alert alert-info hidden-print\" role=\"status\" aria-live=\"polite\">\n        <i class=\"loading-indicator glyphicon glyphicon-refresh\" aria-hidden=\"true\" />\n        <span>{{loadMsg}}</span>\n    </div>\n</template>\n<script>\n\nexport default {\n    name: 'load-progress-bar',\n    props: {\n        display: Boolean,\n        current: Number,\n        total: Number,\n        description: {\n            type: String,\n            default: 'Shows'\n        }\n    },\n    computed: {\n        loadMsg() {\n            const { current, total, description } = this;\n            return `Loaded ${current} out of ${total} ${description}`;\n        }\n    }\n};\n</script>\n<style>\n.load-progress-bar-container {\n    position: fixed;\n    bottom: 10px;\n    right: 10px;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    margin: 0;\n}\n\n@media (max-width: 767px) {\n    .load-progress-bar-container {\n        right: 0;\n        bottom: 0;\n        justify-content: center;\n        width: 100%;\n        border-radius: 0;\n    }\n}\n\n.loading-indicator {\n    margin-right: 0.5em;\n    animation: loading-indicator-spin 1s linear infinite;\n}\n\n@keyframes loading-indicator-spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
